import { render, staticRenderFns } from "./MyBookings.vue?vue&type=template&id=5906fd90&"
import script from "./MyBookings.vue?vue&type=script&lang=js&"
export * from "./MyBookings.vue?vue&type=script&lang=js&"
import style0 from "./MyBookings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports